import React, { Component, Fragment } from 'react'
import { observe, reaction } from 'mobx'
import * as R from 'ramda'
import { Line, Bar } from 'frontend-charts'
import chartRenderSettingsV3 from '../../../../DynamicDashV3/chartRenderSettings'
import colours from './colours'
import { getOptionTitle } from '../../../../../utils/QuestionHelper'

class Chart extends Component {
    // TODO: change back to PureComponent

    benchmarkOrder = {
        // benchmarks should render before the survey/comparison series,
        industry: 0,
        client: 1,
        division: 2,
        portfolio: 3,
    }

    constructor(props) {
        super(props)
        const {
            reportFilter,
            isBenchmarked,
            reportStore,
            categorySet,
            optionTitles,
            question,
            survey,
            dataKey,
            overrideCategories,
        } = props
        this.locale = reportStore.locale
        const data = reportStore.reportDataV2.questions[dataKey]
        const pieChartTypes = [{ // survey pie chart type is always included
            type: 'survey',
            visible: true,
            enabled: true,
        }]
        if (categorySet && overrideCategories !== false) {
            this.categories = categorySet.map((option) => (
                getOptionTitle({
                    langs: option.title,
                    locale: reportStore.locale,
                    defaultLocale: survey.metadata.defaultLocale,
                    initialLocale: question.metadata.initialLocale,
                })
            ))
        } else if (optionTitles) {
            this.categories = optionTitles.map((t) => (
                MergeFields.replace(
                    t,
                    reportStore.locale,
                    reportStore.mergeFields,
                )
            ))
        }
        /**
         * Find benchmarks that have data and store in pieChartTypes
         */
        if (
            reportFilter
            && reportFilter.years[0]
            && this.props.data.comparison
            && this.props.data.comparison[reportFilter.years[0].id]
            && this.props.data.comparison[reportFilter.years[0].id].length > 0
            && this.props.data.comparison[reportFilter.years[0].id].some((dataItem) => dataItem > 0)
        ) {
            pieChartTypes.push({
                type: 'comparison',
                visible: true,
                enabled: true,
            })
        }

        if (isBenchmarked && data.benchmarks) {
            Object.keys(data.benchmarks).forEach((benchmark) => {
                pieChartTypes.push({
                    type: benchmark,
                    visible: false,
                    enabled: props.reportStore.benchmarks.get(benchmark),
                })
            })
        }
        this.state = {
            chartType: props.chartType || 'bar',
            pieChartTypes,
            updated: null,
        }

        if (isBenchmarked) {
            observe(props.reportStore.benchmarks, ({ name, newValue }) => {
                this.toggleBenchmark({
                    benchmark: name,
                    visible: newValue,
                    enabled: true,
                })
            })
        }
        reaction(
            () => props.reportStore.reportDataFetched,
            () => {
                this.setData()
            },
        )
        reaction(
            () => props.reportStore.reportDataFetched,
            () => {
                if (props.reportStore.locale !== this.locale) {
                    // console.log(`setLocale ${props.reportStore.locale} ${this.locale}`)
                } else {
                    const copyOfState = { ...this.state }
                    if (
                        R.hasPath([dataKey, 'comparison', reportFilter.years[0].id])(reportStore.reportData.questions)
                        && reportStore.reportDataV2.questions[dataKey].comparison[reportFilter.years[0].id].length < 1
                    ) {
                        // No comparison data
                        copyOfState.pieChartTypes.find((item) => item.type === 'comparison').enabled = false
                    } else if (
                        R.hasPath([dataKey, 'comparison', reportFilter.years[0].id])(reportStore.reportData.questions)
                        && reportStore.reportDataV2.questions[dataKey].comparison[reportFilter.years[0].id].length > 0
                    ) {
                        // Have comparison data
                        copyOfState.pieChartTypes.find((item) => item.type === 'comparison').enabled = true
                    }
                    this.setData()
                    this.setState(copyOfState)
                }
            },
        )
    }

    componentWillUnmount() {
        const { reportStore, pageQuestionId } = this.props
        reportStore.questionChartRefs.delete(`pageQuestion_${pageQuestionId}`)
    }

    updateCategories = () => {
        const { categories } = this.props
        this[this.chartName].xAxis[0].setCategories(categories)
    }

    toggleBenchmark = (msg) => {
        const { series } = this.props
        const { benchmark, visible } = msg
        if (this.state.chartType !== 'pie') {
            const serieIndex = this[this.chartName].series.findIndex(({ options }) => (options.id === benchmark))
            const s = series.find(({ key }) => key === benchmark)
            console.log(s)
            if (s && s.noData) {
                return
            }
            if (serieIndex > -1) {
                const settings = {
                    showInLegend: visible,
                }
                if (!visible) {
                    settings.visible = false
                }
                // console.log(JSON.stringify(settings))
                this[this.chartName].series[serieIndex].update(settings)
            } else {
                this[this.chartName].series.forEach(({ options }) => console.log(options.id, options.name))
                // console.log(benchmark)
            }
        } else {
            const stateCopy = { ...this.state }
            const target = stateCopy.pieChartTypes.find((a) => a.type === benchmark)
            if (target) {
                target.enabled = visible
                stateCopy.updated = new Date().getTime()
            }

            this.setState(stateCopy)
        }
    }

    setData = () => {
        const {
            reportStore,
            dataKey,
        } = this.props
        const series = this.generateChartData(true)

        this.data = reportStore.reportDataV2.questions[dataKey]

        series.forEach((serie) => {
            const serieIndex = this[this.chartName].series.findIndex(({ name }) => (name === serie.name))
            if (serieIndex > -1) {
                if (serie.data.length > 0) {
                    this[this.chartName].series[serieIndex].setData(serie.data)
                } else {
                    this[this.chartName].series[serieIndex].update({ showInLegend: false, visible: false })
                }
            }
        })
    }

    generatePieSeries = (series) => {
        const { categories } = this.props
        const arrayOfSeries = []

        series.forEach((serie, i) => {
            if (serie.data.length > 0) {
                const newSeries = series[i]
                newSeries.colorByPoint = true
                newSeries.visible = this.state.pieChartTypes[i]
                    ? this.state.pieChartTypes[i].visible
                    : false

                newSeries.data = newSeries.data.map((serie, i) => ({
                    y: (typeof serie === 'object' && Object.prototype.hasOwnProperty.call(serie, 'y')) ? serie.y : serie,
                    name: categories[i],
                    key: categories[i],
                }))

                if (this.state.pieChartTypes[i] && this.state.pieChartTypes[i].enabled) {
                    try {
                        // should render pie chart here
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        })
        return arrayOfSeries
    }

    findSerie = (serieName) => {
        try {
            return this[this.chartName].series.find(({ options }) => (options.id === serieName))
        } catch (e) {
            return {
                visible: true,
            }
        }
    }

    orderSeriesForChart = (series) => {
        const benchmarkSeries = series
            .filter((s) => !['survey', 'comparison'].includes(s.colorKey))
            .sort((a, b) => (this.benchmarkOrder[a.colorKey] ?? 4) - (this.benchmarkOrder[b.colorKey] ?? 4))
        const nonBenchmarkSeries = series.filter((s) => ['survey', 'comparison'].includes(s.colorKey))
        return [...benchmarkSeries, ...nonBenchmarkSeries]
    }

    generateChartData = () => {
        const {
            stacked,
            sortedIndexArray,
            series,
        } = this.props

        let mappedSeries
        if (stacked) {
            mappedSeries = R.clone(series)
                .map((serie) => {
                    serie.data = sortedIndexArray
                        .map((sortedIndex) => (
                            this.data.xOptions[serie.id].pctOfResponses[sortedIndex]
                        ))
                    return serie
                })
                .reverse()
        } else {
            mappedSeries = this.orderSeriesForChart(series).map((s) => {
                const serie = this.generateSerie(
                    s.label, s.key, s.path, s.colorKey, !s.chartHide, !s.hideInLegend,
                )
                return serie
            })
        }
        return mappedSeries
    }

    // key, isBenchmark, visible = false, showInLegend = true
    xaxisLabels = () => {
        const { categories } = this.props

        return categories
    }

    getdata = () => {
        const {
            series, sortedIndexArray, reportStore, dataKey, chartType, isCurrency,
        } = this.props
        const { convertCurrency } = reportStore
        const data = reportStore.reportDataV2.questions[dataKey]
        const a = this.orderSeriesForChart(series).filter((s) => !s.noData).map((serie) => {
            let d = []
            let convertedData = []
            try {
                const serieData = R.pathOr([], serie.path.split('.'))(data)
                d = sortedIndexArray.map((index) => (
                    serieData[index]
                ))
                convertedData = isCurrency ? d.map((v) => (convertCurrency(v))) : d
            } catch (e) {
                console.error(e)
            }

            return {
                name: serie.label,
                stack: null,
                data: chartType === 'bar' ? convertedData.reverse() : convertedData,
            }
        })

        return a
    }

    generateSerie = (label, key, path, colorKey, visible = false, showInLegend = true) => {
        const {
            kpiType, sortedIndexArray, filtered,
        } = this.props
        const { data } = this
        let serieData = []

        serieData = R.pathOr([], path.split('.'))(data)

        const name = label

        const serie = {
            name,
            id: key || label,
            data: serieData ? sortedIndexArray.reduce((data, sortedIndex, index) => {
                const serie = serieData[sortedIndex]
                if (!filtered || !filtered.includes(index)) {
                    data.push(serie)
                }
                return data
            }, []) : [],
            visible: (this.state.chartType === 'pie' && key === 'Comparison') ? true : visible,
            showInLegend: (this.state.chartType !== 'pie') ? showInLegend : false,
            color: colours.colorObj[colorKey],
        }
        if (kpiType === 'NPS') {
            serie.data = serie.data ? serie.data.map((d, i) => ({
                y: d,
                color: R.pathOr([], ['colorObj', 'nps', colorKey])(colours)[i],
            })) : []
        }
        return serie
    }

    updateChartType = () => {
        const { chartType } = this.state
        const series = this.generateChartData(true)

        series.forEach((serie) => {
            const serieIndex = this[this.chartName].series
                .findIndex(({ name }) => (name === serie.name))

            if (serieIndex > -1) {
                this[this.chartName].series[serieIndex].update({ type: chartType })
            }
            this[this.chartName].update({
                chart: {
                    inverted: true,
                },
            })
        })
    }

    pointEvent = (e) => {
        const { pointEvent } = this.props
        if (typeof pointEvent === 'function') {
            pointEvent(e)
        }
    }

    export = () => {
        const { dataKey } = this.props
        const { chartType, pieChartTypes } = this.state

        let html = ''
        if (chartType === 'pie') {
            const width = pieChartTypes.filter(({ enabled, visible }) => (
                enabled && visible
            )).length > 1
                ? 400
                : 800

            pieChartTypes
                .forEach((pieChartType, i) => {
                    if (pieChartType.enabled) {
                        const chartName = `chart_${dataKey}_${i}`
                        html += this[chartName].exportChart({
                            width,
                        })
                    }
                })
        } else {
            const chartName = `chart_${dataKey}`
            html = this[chartName].exportChart()
        }

        return html
    }

    buildChartDivs = () => {
        const { categorySet } = this.props
        /**
         * Here we either build one div for a single chart
         * or multiple if we're rending pie charts
         */
        const style = this.state.chartType === 'bar'
            ? {
                height: `${categorySet.length * 25 + 200}px`,
            }
            : null

        const markup = (this.state.chartType !== 'pie')
            ? <div id={`chart_${this.props.dataKey}`} style={style} />
            : this.state.pieChartTypes
                .map((pieChartType, i) => (
                    (pieChartType.enabled)
                    && (
                        <div style={{
                            width: ( // width 100% if...
                                this.state.pieChartTypes.length < 2 // ...only one pie chart type
                            || this.state.pieChartTypes.filter((pie) => pie.visible).length < 2 // ..only one pie chart is visible
                            || this.state.pieChartTypes.filter((pie) => pie.enabled).length < 2) // ..only one pie chart is enabled
                                ? '100%'
                                : '50%',
                            display: (pieChartType.visible) ? 'inline-block' : 'none',
                        }}
                        >
                            <h4 className="pie-title">{pieChartType.type}</h4>
                            <div id={`chart_${this.props.dataKey}_${i}`} />
                        </div>
                    )
                ))
        return markup
    }

    handlePieViewClick = (e) => {
        const { type } = e.target.dataset
        const copyOfState = { ...this.state }
        const target = copyOfState.pieChartTypes.find((pieChartType) => pieChartType.type === type)

        target.visible = !target.visible
        copyOfState.updated = new Date().getTime()

        this.setState(copyOfState)
    }

    getChart = (props) => {
        const {
            chartType, reportStore, series, isCurrency, currentCurrency, questionTypeCode,
        } = this.props
        const { xAxisLabels, chartData } = props
        const { currencySign } = reportStore
        const percentageFormat = R.pathOr(false, [0, 'type'], series) === 'pct' && questionTypeCode !== 'NF'
            ? '%'
            : undefined
        const format = isCurrency ? currencySign[currentCurrency] : percentageFormat
        const dashStore = {
            appStore: reportStore.appStore,
            benchmarkPeriods: [
                {
                    value: 'ROL36',
                    label: '36 Months',
                    benchmarkType: 'ROL',
                    period: { periodType: 'ROL', duration: 36 },
                    ossPeriod: { periodType: 'last', interval: 'MONTH', duration: 36 },
                },
                {
                    value: 'ROL84',
                    label: 'Long-term',
                    benchmarkType: 'ROL',
                    period: { periodType: 'ROL', duration: 84 },
                    ossPeriod: { periodType: 'last', interval: 'MONTH', duration: 84 },
                },
            ],
            benchmarkPeriod: 'ROL36',
            oId: 6,
            getChartScope: () => 'event',
        }

        const crs = chartRenderSettingsV3
        const layoutEdits = crs(
            {
                chartType: chartType === 'area' ? 'line' : chartType,
                scope: 'event',
                widgetRenderSettings: {
                    showDataLabels: chartType === 'column',
                    showOptionLabels: chartType === 'column',
                    labelPosition: 'top',
                    format,
                    dataDecimals: R.pathOr(false, [0, 'type'], series) === 'pct' ? 0 : 2,
                },
            },
            dashStore,
            xAxisLabels,
            chartData,
        )

        const legendPadding = [
            {
                path: ['grid', 'bottom'],
                value: chartType === 'column' && xAxisLabels.length > 8 ? '24' : '32',
            },
            {
                path: ['legend', 'padding'],
                value: [
                    5, 5, 0, 5,
                ],
            }]
        const barTruncate = [
            { path: ['yAxis', 'axisLabel', 'overflow'], value: 'truncate' },
            { path: ['yAxis', 'axisLabel', 'width'], value: 180 },
            { path: ['grid', 'left'], value: 15 },
        ]
        switch (chartType) {
            case 'line':
                return (
                    <Line
                        {...props}
                        layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding]}
                    />
                )
            case 'area':
                return (
                    <Line
                        {...props}
                        layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding]}
                        stack
                    />
                )
            case 'column':
                return (
                    <Bar
                        {...props}
                        layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding]}
                        defaultSeries={layoutEdits.defaultSeries}
                    />
                )
            case 'bar':
                return (
                    <Bar
                        {...props}
                        xAxisLabels={props.xAxisLabels.reverse().map((l) => l?.replace('’', "'"))}
                        layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding, ...barTruncate]}
                        transpose
                    />
                )
            default:
                return (
                    <Line
                        {...props}
                        layoutEdit={[...layoutEdits.layoutEdit, ...legendPadding]}
                    />
                )
        }
    }

    render() {
        const {
            chartType, percentages, stacked, reportStore, pageQuestionId,
        } = this.props

        // const transpose = chartType === 'bar'
        const xAxisLabels = this.xaxisLabels()
        const chartData = this.getdata()

        let type

        switch (chartType) {
            case 'bar':
            case 'column':
                type = 'bar'
                break
            case 'line':
            case 'area':
                type = 'line'
                break
            default:
                type = 'bar'
        }

        const props = {
            xAxisLabels,
            chartData,
            style: { width: '100%', height: '100%' },
            showLegend: true,
            key: '1',
            tooltipDecimals: 2,
            dataFormat: percentages ? '%' : '',
            defaultSeries: {
                name: '',
                type,
                areaStyle: chartType === 'area' ? {} : null,
                stack: stacked || chartType === 'area' ? 'total' : null,
                label: {
                    show: false,
                },
                emphasis: {
                    focus: 'series',
                },
                data: [],
            },
            setRef: (c) => reportStore.questionChartRefs.set(`pageQuestion_${pageQuestionId}`, c),
        }
        // enables dynamic growth for bar charts when 7 options or greater (i.e. 200 + (7*30) > 300)
        const height = chartType !== 'bar'
            ? '400px'
            : `${200 + (xAxisLabels.length * 30)}px`

        return (
            <Fragment>
                <div style={{ minHeight: '400px', height, padding: '24px' }} className="chartContainer">
                    {this.getChart(props)}
                </div>
            </Fragment>
        )
    }
}

export default Chart
